/* src/app/modules/portal/components/footer/footer.component.scss */
:host {
  background: #1e1e1e;
  font: var(--body-1);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
:host > * {
  display: flex;
  flex-direction: column;
  margin: 2rem;
}
[copyright] {
  color: var(--base-0);
  flex: 1 0;
  font-size: 1rem;
}
[copyright] [title],
[emissions] [title] {
  font: var(--header-1);
  color: var(--base-0);
}
[emissions] {
  display: flex;
  display: none;
  zoom: 0.8;
  opacity: 0.9;
  font-size: 1rem;
  align-items: center;
  margin: auto;
  color: var(--base-0);
  width: 100%;
  flex-direction: column;
}
[emissions] > div {
  display: flex;
  flex-direction: column;
}
[title] {
  text-decoration: none;
}
[feedback] {
  font-size: 1rem;
  --text-highlight: #ec6602;
  text-align: right;
  color: var(--text-highlight);
}
[feedback] [title] {
  font: var(--header-2);
}
[feedback] a {
  color: var(--text-highlight);
}
[feedback] [content] {
  display: flex;
}
[feedback] [content] sh-button {
  margin-top: 0.5rem;
  align-self: end;
}
[feedback] [content] #contact-button {
  background-color: rgba(255, 255, 255, 0.2);
  margin-right: 1rem;
}
[feedback] [content] #contact-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
[feedback] [content] #contact-button:active {
  background-color: rgba(255, 255, 255, 0.06);
}
[screen-phone] :host-context {
  flex-direction: column-reverse;
  zoom: 0.8;
  padding-bottom: 2rem;
}
[screen-phone] :host-context [feedback] {
  text-align: left;
}
[screen-phone] :host-context [feedback] [content] {
  flex-direction: column;
}
[screen-phone] :host-context [feedback] [content] sh-button {
  align-self: start;
}
[screen-phone] :host-context > * {
  margin: 1rem 2rem 0rem 2rem;
}
.siemens-copy {
  margin-block-start: 0.5rem;
}
.phone-privacy-link {
  margin-block-start: 0.2rem;
}
/*# sourceMappingURL=footer.component.css.map */
